import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import ProgressOverview from '../MeineAusbildung/ProgressOverview'
import EmptyState from './UebersichtEmptyState'
import {routeHelper, routeKeys} from '#config/routeKeys'
import KachelListView from './KachelListView'
import {useNavigate} from "react-router-dom";

function PraxisaufgabenKachel({praxisaufgabenModel, showAllItems}) {
  if (!praxisaufgabenModel) {
    return <EmptyTile />
  }

  const {items} = praxisaufgabenModel

  const itemText = item => (
    <div>
      <span>{item.abteilungName}</span>
      <span>{`${item.lastname}, ${item.firstname}`}</span>
    </div>
  )

  const navigate = useNavigate()
  const handleClick = ({azubiId}) => {
    navigate(routeHelper.praxisaufgabenDetail(azubiId))
  }

  const redirect = () => navigate(routeKeys.uebersichtPraxisaufgaben)
  const aufgabenExist = items.length > 0
  const itemsToShow = showAllItems ? items : items.slice(0, 5)
  return (
    <ProgressOverview titleKey="menu_item_praxisaufgabenOverview" showProgressbar={false} testId="dashboard-aufgaben">
      {aufgabenExist ? (
        <>
          <div className="uebersicht__itemsToCheck">
            <div className="uebersicht__itemsToCheck-type">{i18n.t('uebersicht_praxisaufgaben_newtaskstocheck')}</div>
          </div>
          <KachelListView
            testId="kachellist-aufgaben"
            items={itemsToShow}
            showMoreButton={!showAllItems && items.length > 5}
            itemText={itemText}
            handleClick={handleClick}
            showAllRedirect={redirect}
            showAllItemsButtonText={i18n.t('showAll')}
          />
        </>
      ) : (
        <EmptyState text={i18n.t('uebersicht_praxisaufgaben_empty')} />
      )}
    </ProgressOverview>
  )
}

function EmptyTile() {
  return (
    <ProgressOverview titleKey="menu_item_praxisaufgabenOverview" showProgressbar={false} testId="dashboard-aufgaben">
      <div data-testid="praxisaufgabenNoData" className="praxisaufgaben">
        <span>{i18n.t('loading_dashboard_data_failed')}</span>
      </div>
    </ProgressOverview>
  )
}

PraxisaufgabenKachel.propTypes = {
  praxisaufgabenModel: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        azubiId: PropTypes.number,
        firstname: PropTypes.string,
        lastname: PropTypes.string,
        id: PropTypes.string,
      }),
    ),
  }),
  showAllItems: PropTypes.bool.isRequired,
}

export default PraxisaufgabenKachel
